import React from "react";
import MuiRadioGroup from "@mui/material/RadioGroup";
import PropTypes from "prop-types";

/**
 * RadioGroup component wrapper for grouping radio buttons.
 * Wraps Material-UI RadioGroup with theme integration.
 * 
 * @component
 * @example
 * <RadioGroup value={value} onChange={handleChange}>
 *   <FormControlLabel value="option1" control={<Radio />} label="Option 1" />
 *   <FormControlLabel value="option2" control={<Radio />} label="Option 2" />
 * </RadioGroup>
 */
const RadioGroup = ({ children, ...props }) => {
  return <MuiRadioGroup {...props}>{children}</MuiRadioGroup>;
};

RadioGroup.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The default value. Use when the component is not controlled
   */
  defaultValue: PropTypes.any,
  /**
   * The name used to reference the value of the control
   */
  name: PropTypes.string,
  /**
   * Callback fired when a radio button is selected
   */
  onChange: PropTypes.func,
  /**
   * Value of the selected radio button
   */
  value: PropTypes.any,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI RadioGroup behavior

export default RadioGroup;

